import React, { Container, NavItem, NavLink } from "./styles";

import { INavigationButton } from "./navigationButton.d.ts";

/**
 * Componente de botões de navegação
 * @param {INavigationButton} props - Props do componente
 * @returns {JSX.Element} Componente do botão
 **/

const NavigationButton = ({ list, active, onChange }) => {
	return (
		<Container>
			{list.map(({ label, value }, index) => (
				<NavItem key={index}>
					<NavLink
						className={active === value ? "selected" : "unselected"}
						onClick={() => onChange(value)}
					>
						{label}
					</NavLink>
				</NavItem>
			))}
		</Container>
	);
};

export default NavigationButton;
